import React from 'react';
import SiteNavigation from './SiteNavigation';
import HeroSection from './sections/HeroSection';
import HowItWorksSection from './sections/HowItWorksSection';
import FeaturesSection from './sections/FeaturesSection';
import PricingSection from './sections/PricingSection';
import FAQSection from './sections/FAQSection';
import CTASection from './sections/CTASection';
import Footer from './Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="site-canvas overflow-hidden">
      <SiteNavigation />
      <HeroSection />
      <HowItWorksSection />
      <FeaturesSection />
      <CTASection />
      <PricingSection />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default LandingPage;